module.exports = __webpack_public_path__ + "media/os/linux-097dbac1.svg";